import React from "react"

const UsersSignIn = React.lazy(() => import("components/chalky-layout/sign-in"))

export default {
  signInContent: () => <UsersSignIn />
}
